import { useFileUploaderManager as E, isAcceptTypeValid as I, fileInputAcceptTypes as y } from "@systemeio/file-manager";
import { toast as g } from "@systemeio/ui";
import { useTranslation as S } from "../../../i18n.mjs";
import { ImageNameEnum as F, ImageModeEnum as M } from "../image-enum.mjs";
import { addExistingImageSrc as N, hasUploadedImageSrc as b, addUploadedImageSrc as k } from "./state.mjs";
import { isValidUploadedImage as A, isLocalFileUrl as H, loadImageFromUrl as L, removeUploadingImage as f, isImageNode as x } from "./utils.mjs";
const C = 300, j = (D) => {
  const { t: p } = S(), { startUploading: P } = E({
    source: D
  }), h = async (t, r, s) => {
    try {
      const c = await P(t);
      if (!c) {
        g.error(p("global.error")), f(s, r);
        return;
      }
      s.state.doc.descendants((l, m) => {
        var u;
        if (x(l) && ((u = l.attrs.uploadingProps) == null ? void 0 : u.id) === r) {
          const a = {
            ...l.attrs,
            src: c.path,
            uploadingProps: null
          };
          return s.dispatch(
            s.state.tr.setNodeMarkup(m, null, a).setMeta("addToHistory", !1)
          ), k(c.path), !1;
        }
        return !0;
      });
    } catch {
      g.error(p("global.error")), f(s, r);
    }
  }, U = async (t, r, s) => {
    if (t.length === 0) return;
    const c = t.map(async (a) => {
      const o = crypto.randomUUID(), n = URL.createObjectURL(a), e = new Image();
      return e.src = n, await new Promise((d) => {
        e.onload = () => d();
      }), { file: a, id: o, src: n, width: e.naturalWidth, height: e.naturalHeight };
    }), l = await Promise.all(c), { schema: m } = r.state;
    let i = r.state.tr, u = 0;
    l.forEach(({ id: a, src: o, width: n, height: e }) => {
      const d = m.nodes[F.Block].create({
        src: o,
        width: n,
        height: e,
        containerWidth: "auto",
        imageMode: M.BlockCenter,
        uploadingProps: { isUploading: !0, id: a }
      });
      i = i.insert(s + u, d), u += d.nodeSize;
    }), r.dispatch(i), l.forEach(({ file: a, id: o }) => {
      h(a, o, r);
    });
  };
  return { onDrop: (t, r) => {
    if (!r.dataTransfer) return;
    const s = Array.from(r.dataTransfer.files).filter(
      (l) => I(l.type, y.image)
    );
    if (s.length === 0) return !1;
    r.preventDefault();
    const c = t.posAtCoords({ left: r.clientX, top: r.clientY });
    return U(s, t, (c == null ? void 0 : c.pos) ?? 1), !0;
  }, onPaste: (t, r) => {
    if (!r.clipboardData) return;
    const { clipboardData: s } = r, { selection: c } = t.state, { from: l } = c;
    t.state.doc.descendants((a) => (A(a) && N(a.attrs.src), !0));
    const m = Array.from(s.files).filter(
      (a) => I(a.type, y.image)
    );
    if (m.length > 0)
      return r.preventDefault(), U(m, t, l), !0;
    const i = s.getData("text/html");
    return i && i.includes("<img") && setTimeout(() => {
      const a = [];
      t.state.doc.descendants((o, n) => {
        if (!A(o)) return !0;
        const e = o.attrs.src;
        if (b(e)) return !0;
        if (H(e)) {
          const T = t.state.tr.delete(n, n + o.nodeSize);
          return t.dispatch(T), !0;
        }
        const d = crypto.randomUUID();
        return a.push({ pos: n, src: e, id: d }), !0;
      }), a.length !== 0 && (a.forEach(({ pos: o, id: n }) => {
        const e = t.state.doc.nodeAt(o);
        if (!e) return;
        const d = {
          ...e.attrs,
          uploadingProps: { isUploading: !0, id: n }
        };
        t.dispatch(
          t.state.tr.setNodeMarkup(o, null, d).setMeta("addToHistory", !1)
        );
      }), a.forEach(async ({ id: o, src: n }) => {
        const e = await L(n);
        if (!e) {
          g.error(p("global.error")), f(t, o);
          return;
        }
        h(e, o, t);
      }));
    }, C), !1;
  } };
};
export {
  j as useImageDropAndUpload
};
